import { useState } from 'react'
import {
  SettlementGroup,
  SettlementGroupPatchRequest,
  SettlementGroupPostRequest
} from '../../api/Argentia/endpoints/settlementGroups/model/settlementGroups'
import {
  createSettlementGroup,
  deleteSettlementGroup,
  getSettlementGroupsBusinessGroup,
  getSettlementGroupsVirtualBattery,
  getSettlementGroupsWithContracts,
  getSettlementGroupsWithFlexibilities,
  patchSettlementGroup
} from './settlementGroups.service'

// #region Flexibilities
export interface UseSettlementGroupsWithFlexibilities {
  settlementGroupsWithFlexibilities: SettlementGroup[]
  fetchSettlementGroupsWithFlexibilities: () => void
  isFetching: boolean
  onAddLoading: boolean
  onEditLoading: boolean
  onAdd: (request) => Promise<boolean>
  onEdit: (request) => Promise<boolean>
  onDelete: (settlementGroupId: number) => Promise<boolean>
  onRefresh: () => void
}
// export interface UseSettlementGroupsWithFlexibilitiesProps {}

export const useSettlementGroupsWithFlexibilities = (): UseSettlementGroupsWithFlexibilities => {
  const [settlementGroupsWithFlexibilities, setSettlementGroupsWithFlexibilities] = useState<
    SettlementGroup[]
  >([])
  const [isFetching, setIsFetching] = useState<boolean>(false)
  const [isLoadingCreate, setIsLoadingCreate] = useState<boolean>(false)
  const [isLoadingPatch, setIsLoadingPatch] = useState<boolean>(false)

  const fetchSettlementGroupsWithFlexibilities = async () => {
    setIsFetching(true)
    const response = await getSettlementGroupsWithFlexibilities()
    if (response.success) {
      setSettlementGroupsWithFlexibilities(response.data ?? [])
    }
    setIsFetching(false)
  }

  const createNewSettlementGroup = async (
    request: SettlementGroupPostRequest
  ): Promise<boolean> => {
    setIsLoadingCreate(true)
    const response = await createSettlementGroup(request)
    setIsLoadingCreate(false)
    return response.success
  }

  const updateSettlementGroup = async (request: SettlementGroupPatchRequest): Promise<boolean> => {
    setIsLoadingPatch(true)
    const response = await patchSettlementGroup(request)
    setIsLoadingPatch(false)
    return response.success
  }

  const eliminateSettlementGroup = async (settlementGroupId: number): Promise<boolean> => {
    setIsFetching(true)
    const response = await deleteSettlementGroup(settlementGroupId)
    setIsFetching(false)
    return response.success
  }

  return {
    settlementGroupsWithFlexibilities,
    fetchSettlementGroupsWithFlexibilities,
    isFetching,
    onAddLoading: isLoadingCreate,
    onAdd: createNewSettlementGroup,
    onEditLoading: isLoadingPatch,
    onEdit: updateSettlementGroup,
    onDelete: eliminateSettlementGroup,
    onRefresh: fetchSettlementGroupsWithFlexibilities
  }
}

// #endregion Flexibilities

// #region Contracts

export interface UseSettlementGroupsWithContracts {
  settlementGroupsWithContracts: SettlementGroup[]
  fetchSettlementGroupsWithContracts: () => void
  isFetching: boolean
  onRefresh: () => void
}

export const useSettlementGroupsWithContracts = (): UseSettlementGroupsWithContracts => {
  const [settlementGroupsWithContracts, setSettlementGroupsWithContracts] = useState<
    SettlementGroup[]
  >([])
  const [isFetching, setIsFetching] = useState<boolean>(false)

  const fetchSettlementGroupsWithContracts = async () => {
    setIsFetching(true)
    const response = await getSettlementGroupsWithContracts()
    if (response.success) {
      setSettlementGroupsWithContracts(response.data ?? [])
    }
    setIsFetching(false)
  }

  return {
    settlementGroupsWithContracts,
    fetchSettlementGroupsWithContracts,
    isFetching,
    onRefresh: fetchSettlementGroupsWithContracts
  }
}

// #endregion Contracts

// #region VirtualBattery
export interface UseSettlementGroupsVirtualBattery {
  settlementGroupsVirtualBattery: SettlementGroup[]
  fetchSettlementGroupsVirtualBattery: () => void
  isFetching: boolean
  onRefresh: () => void
}

export const useSettlementGroupsVirtualBattery = (): UseSettlementGroupsVirtualBattery => {
  const [settlementGroupsVirtualBattery, setSettlementGroupsVirtualBattery] = useState<
    SettlementGroup[]
  >([])
  const [isFetching, setIsFetching] = useState<boolean>(false)

  const fetchSettlementGroupsVirtualBattery = async () => {
    setIsFetching(true)
    const response = await getSettlementGroupsVirtualBattery()
    if (response.success) {
      setSettlementGroupsVirtualBattery(response.data ?? [])
    }
    setIsFetching(false)
  }

  return {
    settlementGroupsVirtualBattery,
    fetchSettlementGroupsVirtualBattery,
    isFetching,
    onRefresh: fetchSettlementGroupsVirtualBattery
  }
}

// #endregion VirtualBattery

// #region BusinessGroup
export interface UseSettlementGroupsBusinessGroup {
  settlementGroupsBusinessGroup: SettlementGroup[]
  fetchSettlementGroupsBusinessGroup: () => void
  isFetching: boolean
  onRefresh: () => void
}

export const useSettlementGroupsBusinessGroup = (): UseSettlementGroupsBusinessGroup => {
  const [settlementGroupsBusinessGroup, setSettlementGroupsBusinessGroup] = useState<
    SettlementGroup[]
  >([])
  const [isFetching, setIsFetching] = useState<boolean>(false)

  const fetchSettlementGroupsBusinessGroup = async () => {
    setIsFetching(true)
    const response = await getSettlementGroupsBusinessGroup()
    if (response.success) {
      setSettlementGroupsBusinessGroup(response.data ?? [])
    }
    setIsFetching(false)
  }

  return {
    settlementGroupsBusinessGroup,
    fetchSettlementGroupsBusinessGroup,
    isFetching,
    onRefresh: fetchSettlementGroupsBusinessGroup
  }
}

// #endregion VirtualBattery
